import React from "react";
import { makeStyles } from "@material-ui/core/styles";

import * as layouts from "../../../Layouts/index";

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("md")]: {
      // backgroundColor: "white",
    },
  },
}));

const NavAndFooter = (props) => {
  const classes = useStyles();
  const homedata = props.data;
  const navData = homedata?.data[0];
  const NavLinksData = homedata?.data[1];

  const footerData = homedata?.data[2];

  const NavLayout = layouts[navData?.layout];
  const NavLinksLayout = layouts[NavLinksData?.layout];

  const FooterLayout = layouts[footerData?.layout];

  return (
    <div className={classes.root}>
      <NavLayout data={navData} />
      <NavLinksLayout data={NavLinksData} />

      {props.children}
      <FooterLayout data={footerData} />
      {/* {homedata?.data?.map((data, index) => {
        const Layout = layouts[data?.layout];
        return <Layout key={index} data={data} />;
      })} */}
    </div>
  );
};
export default NavAndFooter;
